import React, { useEffect } from 'react'
// import Experience from '../components/experiance'
// import Clients from '../components/clients'
import ProjectList from '../components/project_list'
import Brochure from '../components/Brochure'

export default function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='pb-5'>
      <ProjectList />
      {/* <Brochure /> */}
      {/* <Clients /> */}
    </div>
  )
}
